import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface LinkEntityParams {
  forward_url: string;
}
export class LinkEntity extends BaseEntityClass {
  forward_url: string;
  constructor(params: LinkEntityParams) {
    super();
    this.type = "link";
    this.entity_version = 2;
    this.forward_url = params.forward_url;
  }
}
